import React from "react";

const SendReminderIcon = () => {
  return (
    <>
      <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.583 1.667V5M5.417 1.667V5M17.5 3.333h-15v15h15v-15z"
          stroke="#344054"
          strokeWidth={1.2}
          strokeLinejoin="round"
        />
        <path
          d="M9.176 11.25h4.166m-6.666 0h.007m4.16 3.333H6.675m6.666 0h-.007"
          stroke="#344054"
          strokeWidth={1.2}
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M2.5 7.5h15"
          stroke="#344054"
          strokeWidth={1.2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export default SendReminderIcon;
